












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ExerciseItem from "@/components/classBuilder/ExerciseItem.vue";

@Component({
  components: {
    ExerciseItem

  },
})
export default class ExercisesList extends Vue {
  //TODO change any
  private items:Array<any> = [];
  private page:number = 0;

  @Prop()
  private typeId?: string;

  @Prop()
  private styleId?: string;

  @Prop()
  private teacherId?: string;

  @Watch('typeId')
  watchPropTypeId() {
    this.getExerciseList();
  }

  @Watch('styleId')
  watchPropStyleId() {
    this.getExerciseList();
  }

  @Watch('teacherId')
  watchPropTeacherId() {
    this.getExerciseList();
  }

  private mounted() {
    this.getExerciseList();
  }

  private handleClick(id: string) {
    console.log('handleClick');
  }
  private handleDbClick(id: string) {
    console.log('handleDbClick');
  }

  private getExerciseList() {
    if (this.styleId && this.teacherId) {
      console.log(this.styleId, 'this.styleId')
      console.log(this.teacherId, 'this.teacherId')
      this.items=[{id:'123', title:'Exercise1'}, {id:'234', title:'Exercise2'}, {id:'345', title:'Exercise3'}]
    } else {
      this.items = [];
    }
  }
}
